//service
import { getNotification } from "../../../utils/services/notification";

export function allExcelColumns(row, index) {
  const formatedRow = {
    index,
    title: row.title,
    photo: row.photo ? row.photo : "",
    linkType: row.linkType ? row.linkType : "",
    link: row.link ? row.link : "",
    action:
      row.action &&
      row.action.toUpperCase().trim() !== "INDICAR IDIOMA" &&
      row.action.toUpperCase().trim() !== "RETIRAR IDIOMA"
        ? undefined
        : !row.action
          ? ""
          : row.action,
    language: row.action ? row.language : "",
    message: row.message,
    partGroup:
      (row.partGroup &&
        (row.partGroup.toUpperCase() === "PARTICIPANTE" ||
          row.partGroup.toUpperCase() === "PARTICIPANTES")) ||
      row.partGroup.toUpperCase() === "GRUPO" ||
      row.partGroup.toUpperCase() === "GRUPOS"
        ? row.partGroup
        : undefined,
    sendTo: row.sendTo,
    date: row.date,
    hour: row.hour,
  };

  return formatedRow;
}

export function allExcelColumnsUpdate(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    title: row.title,
    message: row.message,
    date: row.date,
    hour: row.hour,
  };

  return formatedRow;
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    index,
    id: row.id,
    title: row.title,
  };

  return formatedRow;
}

export function findRowsWithError(validRows) {
  const rowsWithError = validRows.filter(
    (row) =>
      Object.values(row).filter((value) => value === undefined).length > 0,
  );
  return rowsWithError;
}

export async function formateDate(date, time) {
  try {
    const [day, month, year] = date.split("/").map(Number);
    const [hour, minute] = time.split(":").map(Number);

    return new Date(year, month - 1, day, hour, minute);
  } catch (error) {
    // console.log("erro ao formatar data", error);
    return "";
  }
}

export async function validationDate(rows) {
  var datesInvalids = [];

  rows.map(async (e, i) => {
    const date = await formateDate(e.date, e.hour);

    if (date < new Date()) {
      datesInvalids.push({
        ...e,
        date: undefined,
        hour: undefined,
      });
    }
  });

  return datesInvalids;
}

export async function validationDateInBase(rows, idEvent) {
  try {
    const resPush = await getAllPushs(idEvent);

    const allPushs = resPush.findOneNotificationData.data;

    var expireDates = [];

    rows.map((row, index) => {
      const search = allPushs.find((push) => push.id === row.id);

      if (search) {
        const isValid = new Date(search.date) > new Date();

        if (!isValid) {
          expireDates.push({
            ...row,
            error: "Push já enviado",
          });
        }
      }
    });

    return expireDates;
  } catch (error) {
    // console.log({ error });
    return [];
  }
}

export const excelColumnsPtBr = {
  Titulo: "title",
  Mensagem: "message",
  Data: "date",
  Hora: "hour",
  "Ação Multi-Idioma": "action",
  Idioma: "language",
  "Participante-Grupo": "partGroup",
  "Enviar para": "sendTo",
};

export const excelColumnsUpdatePtBr = {
  Titulo: "title",
  Mensagem: "message",
  Data: "date",
  Hora: "hour",
  Id: "id",
};

export const excelColumnsDeletePtBr = {
  Id: "id",
  Titulo: "title",
};

async function getAllPushs(idEvent) {
  try {
    const resPush = await getNotification({
      idEvent,
      offset: 1,
      limit: 9999,
      search: "",
      columnSearch: "title",
    });

    return resPush;
  } catch (error) {
    return [];
  }
}

export async function validationIds(rows, idEvent) {
  try {
    const resPush = await getAllPushs(idEvent);

    const allPushs = resPush.findOneNotificationData.data;

    var idsInvalids = [];

    rows.map((e, i) => {
      const search = allPushs.find((push) => push.id === e.id);

      if (!search)
        idsInvalids.push({
          ...e,
          id: undefined,
        });
    });

    return idsInvalids;
  } catch (error) {
    return [];
  }
}

export async function validationPartGroup(rows, allGroups, allParticipants) {
  // validar grupos
  const rowsGroups = rows.filter(
    (row) =>
      row.partGroup &&
      (row.partGroup.toUpperCase() === "GRUPO" ||
        row.partGroup.toUpperCase() === "GRUPOS"),
  );

  var groupsInvalids = [];

  if (rowsGroups && rowsGroups.length > 0) {
    rowsGroups.map((row) => {
      const groups =
        row.sendTo.trim().toUpperCase() === "TODOS"
          ? "TODOS"
          : row.sendTo.split(",").map((e) => {
              return e.trim();
            });

      var isValid = true;

      if (groups !== "TODOS") {
        groups.map((group) => {
          const search = allGroups.find(
            (searchGroup) =>
              searchGroup.name.toUpperCase() === group.toUpperCase(),
          );

          if (!search) isValid = false;
        });
      }

      if (!isValid || allGroups.length === 0) {
        groupsInvalids.push({
          ...row,
          sendTo: undefined,
        });
      }
    });
  }

  if (groupsInvalids && groupsInvalids.length > 0) return groupsInvalids;

  // a mesma validação, so que para os participantes
  const rowsPart = rows.filter(
    (row) =>
      row.partGroup &&
      (row.partGroup.toUpperCase() === "PARTICIPANTE" ||
        row.partGroup.toUpperCase() === "PARTICIPANTES"),
  );

  var partsInvalids = [];

  if (rowsPart && rowsPart.length > 0) {
    rowsPart.map((row) => {
      const parts =
        row.sendTo.trim().toUpperCase() === "TODOS"
          ? "TODOS"
          : row.sendTo.split(",").map((e) => {
              return e.trim();
            });

      var isValid = true;

      if (parts !== "TODOS") {
        parts.map((part) => {
          const search = allParticipants.find(
            (searchPart) =>
              searchPart.email.toUpperCase() === part.toUpperCase(),
          );

          if (!search) isValid = false;
        });
      }

      if (!isValid || allParticipants.length === 0) {
        partsInvalids.push({
          ...row,
          sendTo: undefined,
        });
      }
    });
  }

  return partsInvalids;
}
